import _Vue from 'vue';

import shadowRootDirective from '@/HostApp/ui/directives/shadowRoot';
import sanitizeHtmlDirective from '@/HostApp/ui/directives/sanitizeHtmlDirective';

export default function prepareEnvForHost(Vue: typeof _Vue): void {
	Vue.directive('shadow-root', shadowRootDirective);
	Vue.directive('sanitize-html', sanitizeHtmlDirective);
}
